import { useCallback, useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { RightIcon } from 'foundations-assets/icons/components/RightIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ScrollButton = styled.div.withConfig({
  displayName: "HorizontalScrollContainer__ScrollButton"
})(["position:absolute;top:50%;", ":0;transform:translate( ", "50%,-50% );z-index:2;cursor:pointer;"], props => props.$position === 'left' ? 'left' : 'right', props => props.$position === 'left' ? '-' : '');
const ScrollableWrapper = styled.div.withConfig({
  displayName: "HorizontalScrollContainer__ScrollableWrapper"
})(["overflow-x:scroll;padding-inline:8px;"]);
const Spacer = styled.div.withConfig({
  displayName: "HorizontalScrollContainer__Spacer"
})(["min-width:1px;display:block;"]);
export const HorizontalScrollContainer = ({
  children,
  itemCount
}) => {
  const scrollContainerRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);
  const updateScrollButtons = useCallback(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const {
      scrollLeft,
      scrollWidth,
      clientWidth
    } = container;
    setCanScrollLeft(scrollLeft > 0);
    setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 1);
  }, []);
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    updateScrollButtons();
    container.addEventListener('scroll', updateScrollButtons);
    window.addEventListener('resize', updateScrollButtons);
    return () => {
      container.removeEventListener('scroll', updateScrollButtons);
      window.removeEventListener('resize', updateScrollButtons);
    };
  }, [updateScrollButtons, itemCount]);
  const scrollLeft = useCallback(() => {
    var _scrollContainerRef$c;
    (_scrollContainerRef$c = scrollContainerRef.current) === null || _scrollContainerRef$c === void 0 || _scrollContainerRef$c.scrollTo({
      left: 0,
      behavior: 'smooth'
    });
  }, []);
  const scrollRight = useCallback(() => {
    const container = scrollContainerRef.current;
    if (!container) return;
    container.scrollTo({
      left: container.scrollWidth - container.clientWidth,
      behavior: 'smooth'
    });
  }, []);
  return /*#__PURE__*/_jsxs(Flex, {
    position: "relative",
    marginInline: "-500",
    children: [canScrollLeft && /*#__PURE__*/_jsx(ScrollButton, {
      $position: "left",
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: scrollLeft,
        shape: "circle",
        use: "secondary",
        size: "sm",
        children: /*#__PURE__*/_jsx(LeftIcon, {})
      })
    }), canScrollRight && /*#__PURE__*/_jsx(ScrollButton, {
      $position: "right",
      children: /*#__PURE__*/_jsx(IconButton, {
        onClick: scrollRight,
        shape: "circle",
        use: "secondary",
        size: "sm",
        children: /*#__PURE__*/_jsx(RightIcon, {})
      })
    }), /*#__PURE__*/_jsx(ScrollableWrapper, {
      ref: scrollContainerRef,
      children: /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        flexWrap: "nowrap",
        gap: "200",
        children: [children, /*#__PURE__*/_jsx(Spacer, {})]
      })
    })]
  });
};